import { createSlice } from "@reduxjs/toolkit";
import { Ad } from "../ads/adsTypes";
import { fetchAdDetailsById } from "./adDetailsThunks";
import i18n from "../../i18n";

interface AdDetailsState {
  item: Ad | null;
  loading: boolean;
  error: string | null;
  currentRequestId: string | null;
}

const initialState: AdDetailsState = {
  item: null,
  loading: false,
  error: null,
  currentRequestId: null,
};

const adDetailsSlice = createSlice({
  name: "adDetails",
  initialState,
  reducers: {
    resetAdDetailsState(state) {
      state.item = null;
      state.loading = false;
      state.error = null;
      state.currentRequestId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdDetailsById.pending, (state, action) => {
        state.currentRequestId = action.meta.requestId;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdDetailsById.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.currentRequestId = null;
        state.loading = false;
        state.item = action.payload;
      })
      .addCase(fetchAdDetailsById.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.currentRequestId = null;
        state.loading = false;
        if (action.meta.aborted) return;
        state.error = (action.payload as string) ?? i18n.t("system.unknownError");
      });
  },
});

export const { resetAdDetailsState } = adDetailsSlice.actions;
export default adDetailsSlice.reducer;
